export default __webpack_public_path__ + "static/media/Tiger's Belt of Crouching Calm.3b93d404.jpg";